export const SERVICES = [
  {
    id: "bucatarii",
    title: "Bucătării la Comandă",
    description:
      "Insule moderne, fronturi frezate din MDF sau lemn masiv, feronerie cu amortizare și compartimentare inteligentă, proiectate milimetric pe bucătăria ta.",
    materials: "MDF înfoliat / vopsit · PAL melaminat · Blat quartz sau lemn",
    image: "/assets/real-bucatarie-completa.jpg",
  },
  {
    id: "dressinguri",
    title: "Dressinguri, Dormitoare & Dulapuri",
    description:
      "Sisteme glisante premium, iluminat LED integrat, organizatoare pentru accesorii și dulapuri încastrate pe toată înălțimea camerei.",
    materials: "Sisteme glisare silențioase · MDF · PAL · Oglindă bronz",
    image: "/assets/real-noptiera.jpg",
  },
  {
    id: "usi-scari",
    title: "Uși Interior & Scări din Lemn",
    description:
      "Uși filomuro sau clasice din lemn masiv, trepte și balustrade elegante pentru scări interioare durabile, finisate impecabil.",
    materials: "Stejar masiv · Frasin · Nuc · Finisaje lac UV",
    image: "/assets/real-balustrada.jpg",
  },
  {
    id: "mese-living",
    title: "Mese Masive & Mobilier Living",
    description:
      "Mese de dining din lemn masiv cu margine naturală, comode TV riflate, biblioteci și ansambluri modulare pentru living.",
    materials: "Stejar chitanțat · Metal negru mat · Accente epoxi",
    image: "/assets/real-living-biblioteca.jpg",
  },
  {
    id: "tamplarie-speciala",
    title: "Tâmplărie Specială & Proiecte Unicat",
    description:
      "Riflaje decorative, recepții pentru spații comerciale, placări de pereți cu furnir natural și piese atipice pentru arhitecți.",
    materials: "Furnir natural stejar / nuc · Compact laminat",
    image: "/assets/real-receptie.jpg",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Măsurători & Consultanță",
    description:
      "Ne deplasăm la spațiul tău pentru măsurători milimetrice, analizăm cerințele și stabilim împreună bugetul optim.",
  },
  {
    step: "02",
    title: "Alegerea Materialelor & Feroneriei",
    description:
      "Vezi și atingi mostre de lemn, MDF, PAL și feronerie de top, ca să alegi nuanțele și funcționalitățile potrivite.",
  },
  {
    step: "03",
    title: "Execuția în Atelier",
    description:
      "Debitare, cantuire precisă, frezare și asamblare atentă, iar fiecare piesă prinde viață în atelierul nostru.",
  },
  {
    step: "04",
    title: "Transport & Montaj Profesionist",
    description:
      "Livrare sigură și instalare curată direct la locație, cu reglaje de finețe făcute de echipa noastră.",
  },
];

export const WHY_US = [
  {
    icon: "award",
    title: "Peste 15 ani de experiență",
    desc: "Măiestrie meșteșugărească în prelucrarea lemnului, combinată cu tehnologii moderne de execuție.",
  },
  {
    icon: "shield",
    title: "Feronerie & materiale rezistente",
    desc: "Folosim materiale și feronerie testate în timp, alese să reziste la uzura de zi cu zi.",
  },
  {
    icon: "clock",
    title: "Termene respectate & montaj curat",
    desc: "Ne ținem de data de predare stabilită și lăsăm spațiul impecabil după montaj.",
  },
  {
    icon: "badge",
    title: "Garanție pentru fiecare lucrare",
    desc: "Fiecare proiect pleacă din atelier cu garanție și cu suport direct pentru ajustări ulterioare.",
  },
];

export const PORTFOLIO_GROUPS = [
  {
    id: "bucatarii",
    title: "Bucătării la comandă",
    description: "Fronturi antracit, blaturi din stejar, nișe cu LED și compartimentare pe măsură.",
    items: [
      {
        title: "Bucătărie antracit & stejar cu LED",
        photos: [
          "/assets/real-bucatarie-completa.jpg",
          "/assets/real-bucatarie-sertare.jpg",
          "/assets/real-bucatarie-fereastra.jpg",
          "/assets/real-bucatarie-nisa.jpg",
          "/assets/real-bucatarie.jpg",
        ],
      },
    ],
  },
  {
    id: "scari",
    title: "Scări & balustrade din lemn",
    description: "Trepte, balustrade și scări interioare executate și montate chiar de echipa noastră.",
    items: [
      { title: "Scară interioară din lemn masiv", photos: ["/assets/real-scara-masiv.jpg"] },
      { title: "Balustradă din stejar", photos: ["/assets/real-balustrada.jpg"] },
      { title: "Scară cu trepte plutitoare · montaj", photos: ["/assets/real-scara-montaj.jpg"] },
    ],
  },
  {
    id: "dressinguri",
    title: "Dressinguri & dormitoare",
    description: "Dressinguri, dulapuri și piese de dormitor optimizate pe milimetru pentru spațiul tău.",
    items: [
      {
        title: "Noptieră dormitor · de la crud la vopsit",
        beforeAfter: true,
        photos: ["/assets/real-corp-lucru.jpg", "/assets/real-noptiera.jpg"],
      },
      { title: "Dressing cu LED", photos: [] },
      { title: "Dulap cu glisare", photos: [] },
    ],
  },
  {
    id: "lemn-masiv",
    title: "Lemn masiv & meșteșug",
    description: "Scaune sculptate, corpuri de mobilier și piese lucrate manual, direct în atelier.",
    items: [
      {
        title: "Restaurare scaune sculptate · înainte / după",
        beforeAfter: true,
        photos: ["/assets/real-scaune-lemn.jpg", "/assets/real-scaune-negre.jpg"],
      },
    ],
  },
  {
    id: "living",
    title: "Living, biblioteci & recepții",
    description: "Biblioteci pe toată înălțimea, mobilier de living și recepții pentru spații comerciale.",
    items: [
      {
        title: "Living cu bibliotecă la comandă",
        photos: ["/assets/real-living-biblioteca.jpg", "/assets/real-biblioteca.jpg"],
      },
      { title: "Recepție spațiu comercial", photos: ["/assets/real-receptie.jpg"] },
    ],
  },
];

export const HERO_IMAGE = "/assets/real-receptie.jpg";

export const WORKSHOP_IMAGE =
  "https://images.unsplash.com/photo-1547609434-b732edfee020?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";
